import { getThumbnailUrlForMakoImages } from "../../apiUtils";

export default function NonPlayableVideo({ src }: { src: string }) {
  const thumbnailUrl = getThumbnailUrlForMakoImages({ url: src });

  return (
    <div>
      <div className="mb-2">
        <p className="text-xl text-blue-400">
          *Video format not playable. Please download video to view in entirety.
        </p>
      </div>
      {thumbnailUrl ? (
        <img
          src={thumbnailUrl}
          alt="Video thumbnail"
          className="h-auto max-h-[600px] w-auto max-w-[1067px]"
        />
      ) : (
        <p>Thumbnail not available.</p>
      )}
    </div>
  );
}
